<div class="flex flex-row justify-start items-center space-x-4">
  @if (editMode) {
    <p class="flex-shrink-0 hidden sm:block">{{ label }}:</p>
    <mat-form-field class="flex-shrink">
      <mat-label>Search for assignee</mat-label>
      <input
        matInput
        type="text"
        [formControl]="filter"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="save($event.option.value)"
        [displayWith]="displayWith"
      >
        <mat-option [value]="unassignedUser">
          <i>Unassigned</i>
        </mat-option>
        <mat-option
          *ngFor="let assignee of options$ | async"
          [value]="assignee"
        >
          {{ assignee.label }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <button
      mat-icon-button
      (click)="toggleEdit()"
      class="w-3 h-3 text-xs"
      matTooltip="Cancel"
    >
      <mat-icon>close</mat-icon>
    </button>
  } @else {
    <p class="flex-shrink-0">{{ label }}:</p>
    <p>{{ value?.label ?? 'Unassigned' }}</p>
    <button mat-icon-button (click)="toggleEdit()" class="w-6 h-6 text-xs">
      <mat-icon>edit</mat-icon>
    </button>
  }
</div>
